@if (mode === 'default') {
  <header class="header" [class.mobile]="showMenuButton">
    <div class="left" [class.mobile]="showMenuButton">
      @if (showMenuButton) {
        <button
          class="menu-btn"
          type="button"
          [attr.aria-label]="'HEADER.OPEN_MENU' | translate"
          (click)="menuClick.emit()">
          <i class="fa-solid fa-bars menu"></i>
        </button>
      }

      <span class="title-group">
        @if (icon) { <span class="title-icon"><i [class]="icon"></i></span> }
        <span class="title-text">{{ titleKey ? (titleKey | translate) : title }}</span>
        @if (subtitleKey || subtitle) {
          <span class="title-sub">{{ subtitleKey ? (subtitleKey | translate) : subtitle }}</span>
        }
      </span>
    </div>

    <div class="right">

      <div class="lang-dropdown" #langRef [class.open]="langOpen">
        <button
          type="button"
          class="lang-trigger"
          [attr.aria-label]="'LANGUAGE.TITLE' | translate"
          [attr.aria-expanded]="langOpen"
          (click)="toggleLang()">
          <span class="flag-box">
            <img
              [src]="selectedLang?.flag || '/assets/images/flags/br.svg'"
              alt=""
              class="flag"
              (error)="onFlagError($event)" />
          </span>
          <span class="chevron-box">
            <i class="fa-regular fa-chevron-down chevron"></i>
          </span>
        </button>

        @if (langOpen) {
          <div class="lang-menu anim-wrap" role="menu" [@expandFade]>
            @for (l of languages; track l.code) {
              <button
                type="button"
                class="lang-item"
                role="menuitem"
                [attr.aria-label]="('LANGUAGE.OPTION.' + l.code) | translate"
                [class.active]="currentLang === l.code"
                (click)="changeLanguage(l.code)">
                <img [src]="l.flag" alt="" class="flag" (error)="onFlagError($event)" />
                <span class="label">{{ ('LANGUAGE.OPTION.' + l.code) | translate }}</span>
              </button>
            }
          </div>
        }
      </div>

      @if (!showMenuButton) {
        <span class="user">{{ user()?.name || "—" }}</span>
        <app-avatar
          [size]="32"
          [cursor]="true"
          [altText]="user()?.name || ('HEADER.USER' | translate)"
          [imageUrl]="avatarUrl()">
        </app-avatar>
        <button class="logout" type="button" (click)="logout()">
          <span>{{ 'LOGOUT' | translate }}</span>
          <i class="fa-solid fa-arrow-right-from-bracket"></i>
        </button>
      }
    </div>
  </header>
} @else {
  <header class="header page">
    @if (showBack) {
      <button class="back-btn" type="button" (click)="back()" [attr.aria-label]="'HEADER.BACK' | translate">
        <i class="fa-light fa-chevron-left"></i>
      </button>
    }

    <span class="title title-group">
      @if (icon) { <span class="title-icon"><i [class]="icon"></i></span> }
      <span class="title-lines">
        <span class="title-text">
          {{ titleKey ? (titleKey | translate : (titleParams || {})) : title }}
        </span>
        @if (subtitleKey || subtitle) {
          <span class="title-sub">
            {{ subtitleKey ? (subtitleKey | translate : (subtitleParams || {})) : subtitle }}
          </span>
        }
      </span>
    </span>

    <div class="lang-dropdown" #langRef [class.open]="langOpen">
      <button
        type="button"
        class="lang-trigger"
        [attr.aria-label]="'LANGUAGE.TITLE' | translate"
        [attr.aria-expanded]="langOpen"
        (click)="toggleLang()">
        <span class="flag-box">
          <img
            [src]="selectedLang?.flag || '/assets/images/flags/br.svg'"
            alt=""
            class="flag"
            (error)="onFlagError($event)" />
        </span>
        <span class="chevron-box">
          <i class="fa-regular fa-chevron-down chevron"></i>
        </span>
      </button>

      @if (langOpen) {
        <div class="lang-menu anim-wrap" role="menu" [@expandFade]>
          @for (l of languages; track l.code) {
            <button
              type="button"
              class="lang-item"
              role="menuitem"
              [attr.aria-label]="('LANGUAGE.OPTION.' + l.code) | translate"
              [class.active]="currentLang === l.code"
              (click)="changeLanguage(l.code)">
              <img [src]="l.flag" alt="" class="flag" (error)="onFlagError($event)" />
              <span class="label">{{ ('LANGUAGE.OPTION.' + l.code) | translate }}</span>
            </button>
          }
        </div>
      }
    </div>
  </header>
}
